import AgencySaleOrderListView from 'features/Agency/components/AgencySaleOrderListView';
import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import AppRoute from 'general/constants/AppRoute';
import useRouter from 'hooks/useRouter';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

function AgencySaleOrderListScreen(props) {
  // ---- PROPERTIES ----
  const router = useRouter();
  const { showFullUI = true } = props;
  const { user } = useSelector((state) => state.auth);
  const prefKey = useMemo(() => {
    const userId = user.userId;
    const pathName = router.pathname;
    const key = `${userId}_${pathName}`;
    return key;
  }, [user, router]);
  const { pathname } = router;
  const { agencyId, month } = router.query
  const mode =
    pathname === AppRoute.saleOrder ? 'SELL' : pathname === AppRoute.purchaseOrder ? 'BUY' : '';

  return (
    <div>
      {showFullUI ? (
        <KT01BaseLayout isFullScreen={true}>
          <div className="container-fluid px-4 my-4">
            <AgencySaleOrderListView showFullUI={true} agencyId={agencyId} month={month} orderMode={mode} prefKey={prefKey} />
          </div>
        </KT01BaseLayout>
      ) : (
        <div className="container-fluid px-4 my-4">
          <AgencySaleOrderListView showFullUI={true} agencyId={agencyId} month={month} orderMode={mode} prefKey={prefKey} />
        </div>
      )}
    </div>
  );
}

export default AgencySaleOrderListScreen;
